import React, { useState, useCallback, useEffect } from 'react'
import zoomIcon from '../../../assets/images/zoom-icon.png'
import CancelIcon from '../../../assets/images/restrict-icon.png'
import RescheduleIcon from '../../../assets/images/Reschedule_Icon.png'
import CancelSlotModal from './Right/Modals/CancelSlotModal'
import CancelReasonModal from './Right/Modals/CancelReasonModal'
import { useOpenChatMutation } from '../../../services/chatApi'
import { useCancelBookedSlotMutation } from '../../../services/coachApi'
import { coachActions } from '../../../services/coachSlice'
import loader from '../../../assets/images/loader.gif'
import moment from 'moment-timezone'
import { ToastContainer, toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { therapistActions } from '../../../services/therapistSlice'
import PlanModal from '../FindTherapist/PlanModal'
import { IoAlertCircle } from 'react-icons/io5'
import { IoIosInformationCircleOutline } from "react-icons/io";
// Utility helper function: convert UTC date/time to user timezone and format
const deviceTimezone = localStorage.getItem('device_timezone')
function formatUTCToUserTZ(date, time, timezone = deviceTimezone, dateFormat = 'DD/MM/YYYY', timeFormat = 'hh:mm A') {
  if (!date || !time) return ''
  // Append seconds if missing, ensure valid ISO string
  const formattedTime = time.length === 5 ? `${time}:00` : time
  const utcDateTime = `${date}T${formattedTime}Z` // UTC datetime string
  return moment.utc(utcDateTime).tz(timezone).format(`${dateFormat} [at] ${timeFormat}`)
}

// Helpers to format only date or only time in user timezone if needed
function formatDateToUserTZ(date, timezone = 'Asia/Kolkata', dateFormat = 'DD/MM/YYYY') {
  if (!date) return ''
  return moment.utc(date).tz(timezone).format(dateFormat)
}
function formatTimeToUserTZ(date, time, timezone = 'Asia/Kolkata', timeFormat = 'hh:mm A') {
  if (!date || !time) return ''
  const formattedTime = time.length === 5 ? `${time}:00` : time
  const utcDateTime = `${date}T${formattedTime}Z`
  return moment.utc(utcDateTime).tz(timezone).format(timeFormat)
}

const UpcomingSessions = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)
  const [pageRefreshKey, setPageRefreshKey] = useState(0);
  const chatlistuser = useSelector((state) => state.plan.reservation)
  const activeCoachId = useSelector((state) => state.coachReducer.coach_id)
  const activeChatItem = chatlistuser?.data?.find(item => item.coach_id === activeCoachId)


  const userDetails = useSelector(state => state.userReducer)


  const userTimezone = userDetails?.user?.data?.timezone?.name || deviceTimezone


  const planReservation = useSelector((state) => state.coachReducer.plan_reservation)

  const [cancelModal, setCancelModal] = useState(false)
  const [cancelReasonModal, setCancelReasonModal] = useState(false)
  const [errMessage, setErrMessage] = useState('')

  const [cancelBookedSlot, { isLoading: loadingToCancel }] = useCancelBookedSlotMutation()

  const [bookingDetails, setBookingDetails] = useState({})
  const [openChat, { isLoading: chatOpenLoading, isSuccess: chatOpenSuccess }] = useOpenChatMutation({})
  const coachId = useSelector((state) => state.coachReducer.coach_id)


  const chatOpenHandler = useCallback(async () => {
    const formData = new FormData()
    formData.append('person_id', coachId)
    formData.append('page_no', 1)
    try {
      const response = await openChat(formData)

      // console.log(response);

      setBookingDetails(response?.data?.data?.[response.data.data.length - 1] || {})
    } catch (error) {

    }
  }, [coachId, openChat, pageRefreshKey])

  const handleRefreshData = () => {
    chatOpenHandler()
  }
  useEffect(() => {
    chatOpenHandler()
  }, [chatOpenHandler])

  const planReserv = activeChatItem?.plan_reservation


  const planDetails = planReserv?.plan_details
  const hasFreeConsultation =
    planReserv !== null &&
    activeChatItem?.is_relation_paused?.trim().toLowerCase() === 'no' &&
    Number(planDetails?.free_consultation_no) > 0 &&
    Number(planReserv?.avail_consult) > 0


  const cancelBookedSlotHandler = async (cancel_reason) => {
    const formData = new FormData()
    formData.append('booking_id', bookingDetails?.booking_id)
    formData.append('coach_id', bookingDetails?.booking_coach_id)
    formData.append('category_id', bookingDetails?.booking_category_id)
    formData.append('reason', cancel_reason)

    try {
      const response = await cancelBookedSlot(formData)
      if (response?.data?.code === 'Success') {
        toast.success('Cancelled Successfully!')
        setBookingDetails((prevState) => ({ ...prevState, booking_status: 'cancelled' }))
        setErrMessage('')
        // console.log(bookingDetails);

        dispatch(coachActions.toggleCoach({ sessionDate: undefined, sessionTime: undefined, }))
        setTimeout(() => {
          handleCancelReasonModal('cancelReasonModal')
        }, 2000)
      } else if (response?.error?.status === 400) {
        if (
          response?.error?.data?.data?.error?.[0] ===
          'Either booking does not exists or does not belongs to you'
        ) {
          setErrMessage('Booking already cancelled by Coach!')
        }
      }
    } catch (error) {

    }
  }

  const handleCancelReasonModal = (val) => {
    if (val === 'cancelSlotModal') {
      setCancelModal(false)
      setCancelReasonModal(true)
    }
    if (val === 'cancelReasonModal') {
      setCancelModal(false)
      setCancelReasonModal(false)
    }
  }

  const redirectRescheduleHandler = () => {

    localStorage.setItem('rescheduleclick', 'yes')
    dispatch(therapistActions.setBtnClick('yes'))
    dispatch(therapistActions.setBookingDetailsReschedule(bookingDetails))
    dispatch(therapistActions.setBG(bookingDetails?.booking_category_color))
    dispatch(therapistActions.setCategoryIcon(bookingDetails?.booking_category_icon))
    dispatch(therapistActions.setCategoryName(bookingDetails?.booking_category_name))
    localStorage.setItem('Booking_id', bookingDetails?.booking_coach_id)
    dispatch(therapistActions.setCoachIdBN(bookingDetails?.booking_coach_id))
    dispatch(therapistActions.setBookingId(bookingDetails?.booking_id))
    dispatch(therapistActions.setCategoryId(bookingDetails?.category_id))
    navigate(
      `/findtherapist/${bookingDetails?.booking_category_name}?${bookingDetails?.booking_category_id}`
    )


  }
  // console.log(bookingDetails);

  const redirectBookNow = () => {


    dispatch(therapistActions.setBtnClick('no'))


    navigate(
      `/findtherapist/${bookingDetails?.booking_category_name}?${bookingDetails?.booking_category_id}`
    )
    dispatch(therapistActions.setBG(bookingDetails?.booking_category_color))
    dispatch(therapistActions.setCategoryIcon(bookingDetails?.booking_category_icon))
    dispatch(therapistActions.setCategoryName(bookingDetails?.booking_category_name))
    localStorage.setItem('Booking_id', bookingDetails?.booking_coach_id)
    dispatch(therapistActions.setCoachIdBN(bookingDetails?.booking_coach_id))

  }

  // Compute these once on each render
  const now = moment().tz(userTimezone)
  const bookingDateTimeUTC = moment.utc(
    `${bookingDetails?.booking_session_date}T${bookingDetails?.booking_session_time}`
  )
  const bookingDateTimeLocal = bookingDateTimeUTC?.clone().tz(userTimezone)
  // Reschedule 
  const hoursLeft = bookingDateTimeLocal?.diff(now, 'hours');


  const canReschedule = hoursLeft >= 24 && bookingDetails?.booking_is_rescheduled?.toString()?.trim()?.toLowerCase() !== "yes";
  // console.log(canReschedule);
  const canCancel = hoursLeft >= 24 && bookingDetails?.booking_is_free_session
    ?.toString()
    ?.trim()
    ?.toLowerCase() === 'no';
  //  console.log(canCancel);
  //  console.log(bookingDetails?.booking_is_free_session);

  let content = null
  //  console.log(bookingDetails);
  if (bookingDetails?.booking_session_date && bookingDetails?.booking_session_time) {



    if (bookingDateTimeLocal.isAfter(now)) {
      // Upcoming session
      content = (
        <>
          <div className="w-full text-[1.3rem] font-ubuntu leading-8 text-center">
            Upcoming Session
          </div>
          <div className="w-full pb-4 font-bold text-[1.2rem] font-ubuntu leading-8 text-center">
            {formatUTCToUserTZ(
              bookingDetails.booking_session_date,
              bookingDetails.booking_session_time,
              userTimezone
            )}
          </div>

          <div className="flex justify-center flex-col w-[155px] mx-auto">
            {canReschedule && <button
              type="button"
              className="bg-[#FFDBB0] flex mt-4 font-ubuntu justify-center items-center rounded-[20px] font-semibold pl-3 h-[40px]"
              onClick={redirectRescheduleHandler}
            >
              <div className="mt-0 mr-3">
                <img src={RescheduleIcon} alt="" className="w-[20px]" />
              </div>
              Reschedule
            </button>}
            {canCancel && <button
              type="button"
              className="bg-[#FFDBB0] flex mt-4 font-ubuntu justify-center items-center rounded-[20px] font-semibold pl-3 h-[40px]"
              onClick={() => setCancelModal(true)}
            >
              <div className="mt-0 mr-3">
                <img src={CancelIcon} alt="" className="w-[20px]" />
              </div>
              Cancel
            </button>}

          </div>
          {(canCancel || canReschedule) && <div className="mt-4 flex items-start gap-2 text-xs text-gray-500">
            <IoIosInformationCircleOutline className='w-4 h-4 mt-0.5 flex-shrink-0' />

            <p className='font-bold'>Note: Each appointment can be rescheduled only once.</p>
          </div>}
        </>
      )
    } else {


      // Past session or no upcoming
      content = (
        <>
          <div className="w-full text-[1.35rem] font-ubuntu font-bold leading-8 text-center">
            No Upcoming Session
          </div>
          {!hasFreeConsultation && (
            <div className="flex justify-center w-[155px] mx-auto">
              <button
                type="button"
                className={`bg-[#FFDBB0] mt-4 font-ubuntu rounded-[20px] font-semibold h-[40px] text-center text-[#F76411] block w-full ${bookingDetails?.booking_category_ctive === 0
                  ? 'cursor-no-drop'
                  : 'cursor-pointer'
                  }`}
                onClick={() => {
                  localStorage.setItem("categoryid", bookingDetails?.booking_category_id)
                  if (bookingDetails?.booking_category_ctive === 0) {
                    return
                  }
                  redirectBookNow()
                }}
              >
                Book Now
              </button>
            </div>
          )}
        </>
      )
    }
  } else {
    // console.log("gh");
    const hasBookingDetails =
      bookingDetails && Object.keys(bookingDetails).length > 0
    // If no booking session date/time
    content = (
      <>
        <div className="w-full text-[1.35rem] font-ubuntu font-bold leading-8 text-center">
          No Upcoming Session
        </div>
        {!hasFreeConsultation && hasBookingDetails && (
          <div className="flex justify-center w-[155px] mx-auto">
            <button
              type="button"
              className={`bg-[#FFDBB0] mt-4 font-ubuntu rounded-[20px] font-semibold h-[40px] text-center text-[#F76411] block w-full ${bookingDetails?.booking_category_ctive === 0
                ? 'cursor-no-drop'
                : 'cursor-pointer'
                }`}
              onClick={() => {
                if (bookingDetails?.booking_category_ctive === 0) {
                  return
                }
                redirectBookNow()
              }}
            >
              Book Now
            </button>
          </div>
        )}
      </>
    )

  }

  if (bookingDetails?.booking_status === 'cancelled' || bookingDetails?.booking_status === 'completed') {


    content = (
      <>
        <div className="w-full text-[1.35rem] font-ubuntu font-bold leading-8 text-center">
          No Upcoming Session
        </div>
        <div className="flex justify-center w-[155px] mx-auto">
          <button
            type="button"
            className={`bg-[#FFDBB0] mt-4 font-ubuntu rounded-[20px] font-semibold h-[40px] text-center text-[#F76411] block w-full ${bookingDetails?.booking_category_ctive === 0 ? 'cursor-no-drop' : 'cursor-pointer'
              }`}
            onClick={() => {
              if (bookingDetails?.booking_category_ctive === 0) return
              redirectBookNow()
            }}
          >
            Book Now
          </button>
        </div>
      </>
    )
  }

  return (
    <aside className="bg-[#FFFFFF] border border-[#FFDBB0] rounded-2xl w-[250px] mt-3 p-4 text-center py-6 relative flex flex-col justify-center basis-2/4">
      {/* <ToastContainer hideProgressBar /> */}

      <div>{chatOpenLoading ? <img src={loader} className="w-10 h-10 mx-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" alt="loader" /> : content}</div>

      {cancelModal && (
        <CancelSlotModal
          closeModal={() => setCancelModal(false)}
          handleCancelReasonModal={handleCancelReasonModal}
        />
      )}
      {cancelReasonModal && (
        <CancelReasonModal
          handleCancelReasonModal={handleCancelReasonModal}
          cancelBookedSlotHandler={cancelBookedSlotHandler}
          errMessage={errMessage}
          setErrMessage={setErrMessage}
          setBookingDetails={setBookingDetails}
          bookingDetails={bookingDetails}
        />
      )}

      {hasFreeConsultation && (
        <div className="flex justify-center w-max mx-auto px-3">
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="bg-[#FFDBB0] px-2 mt-4 font-ubuntu rounded-[20px] font-semibold h-[40px] text-center text-[#F76411] block w-full"
          >
            Free Consultation
          </button>
        </div>
      )}
      {showModal && (
        <PlanModal
          coachId={coachId}
          planReservation={activeChatItem?.plan_reservation}
          closeModal={() => setShowModal(false)}
          // key={pageRefreshKey}
          // onBookingSuccess={handleRefreshData}
          triggerRefresh={() => setPageRefreshKey(k => k + 1)}
        />
      )}

    </aside>
  )
}

export default UpcomingSessions